const DatasetSubPages = {
  IDENTIFY: 0,
  IDENTIFY_IN_PROGRESS: 1,
  PROPOSE: 2,
  VALIDATION_IN_PROGRESS: 3,
  ACCEPT: 4
}

export default DatasetSubPages
